module.exports = __webpack_public_path__ + "static/juan-rivas-b79d099a82d1f2019fec80c6a1a19f12.png";